import { render, staticRenderFns } from "./ProjectdeskSteps.vue?vue&type=template&id=a82c9162"
import script from "./ProjectdeskSteps.vue?vue&type=script&lang=js"
export * from "./ProjectdeskSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports